/* This file is generated by Kubb. DO NOT EDIT MANUALLY. */

import type { CreateExerciseMutationRequest } from './types/CreateExercise.ts';
import type { CreateRoutineMutationRequest } from './types/CreateRoutine.ts';
import type { CreateSessionMutationRequest } from './types/CreateSession.ts';
import type { DeleteExercisePathParams } from './types/DeleteExercise.ts';
import type { DeleteRoutinePathParams } from './types/DeleteRoutine.ts';
import type { DeleteSessionPathParams } from './types/DeleteSession.ts';
import type { GetExercisePathParams } from './types/GetExercise.ts';
import type { GetRoutinePathParams } from './types/GetRoutine.ts';
import type { GetSessionPathParams } from './types/GetSession.ts';
import type { SearchExercisesMutationRequest } from './types/SearchExercises.ts';
import type { SearchRoutinesMutationRequest } from './types/SearchRoutines.ts';
import type { SearchSessionsMutationRequest } from './types/SearchSessions.ts';
import type { UpdateExercisePathParams, UpdateExerciseMutationRequest } from './types/UpdateExercise.ts';
import type { UpdateRoutinePathParams, UpdateRoutineMutationRequest } from './types/UpdateRoutine.ts';
import type { UpdateSessionPathParams, UpdateSessionMutationRequest } from './types/UpdateSession.ts';
import type { Client } from '@kubb/plugin-client/clients/fetch';
import { createExercise } from './clients/createExercise.ts';
import { createRoutine } from './clients/createRoutine.ts';
import { createSession } from './clients/createSession.ts';
import { deleteExercise } from './clients/deleteExercise.ts';
import { deleteRoutine } from './clients/deleteRoutine.ts';
import { deleteSession } from './clients/deleteSession.ts';
import { getExercise } from './clients/getExercise.ts';
import { getRoutine } from './clients/getRoutine.ts';
import { getSession } from './clients/getSession.ts';
import { searchExercises } from './clients/searchExercises.ts';
import { searchRoutines } from './clients/searchRoutines.ts';
import { searchSessions } from './clients/searchSessions.ts';
import { updateExercise } from './clients/updateExercise.ts';
import { updateRoutine } from './clients/updateRoutine.ts';
import { updateSession } from './clients/updateSession.ts';

export class ApiClient {
  constructor(private readonly client: Client) {}

  getRoutine(id: GetRoutinePathParams['id']) {
    return getRoutine(id, { client: this.client });
  }
  updateRoutine(id: UpdateRoutinePathParams['id'], data: UpdateRoutineMutationRequest) {
    return updateRoutine(id, data, { client: this.client });
  }
  deleteRoutine(id: DeleteRoutinePathParams['id']) {
    return deleteRoutine(id, { client: this.client });
  }
  searchRoutines(data: SearchRoutinesMutationRequest) {
    return searchRoutines(data, { client: this.client });
  }
  createRoutine(data: CreateRoutineMutationRequest) {
    return createRoutine(data, { client: this.client });
  }
  getSession(id: GetSessionPathParams['id']) {
    return getSession(id, { client: this.client });
  }
  updateSession(id: UpdateSessionPathParams['id'], data: UpdateSessionMutationRequest) {
    return updateSession(id, data, { client: this.client });
  }
  deleteSession(id: DeleteSessionPathParams['id']) {
    return deleteSession(id, { client: this.client });
  }
  searchSessions(data: SearchSessionsMutationRequest) {
    return searchSessions(data, { client: this.client });
  }
  createSession(data: CreateSessionMutationRequest) {
    return createSession(data, { client: this.client });
  }
  getExercise(id: GetExercisePathParams['id']) {
    return getExercise(id, { client: this.client });
  }
  updateExercise(id: UpdateExercisePathParams['id'], data: UpdateExerciseMutationRequest) {
    return updateExercise(id, data, { client: this.client });
  }
  deleteExercise(id: DeleteExercisePathParams['id']) {
    return deleteExercise(id, { client: this.client });
  }
  searchExercises(data: SearchExercisesMutationRequest) {
    return searchExercises(data, { client: this.client });
  }
  createExercise(data: CreateExerciseMutationRequest) {
    return createExercise(data, { client: this.client });
  }
}
